export default "__VITE_ASSET__DafGLaP$__"